import { render, staticRenderFns } from "./ContactsCoTable.vue?vue&type=template&id=56d96d0e&scoped=true"
import script from "./ContactsCoTable.vue?vue&type=script&lang=js"
export * from "./ContactsCoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d96d0e",
  null
  
)

export default component.exports